import React from "react"
import "./styles.scss"

const FeaturedLogos = () => (
    <section className="featured-logos">
        <div className="inner featured-logos__inner">
            <img
                className="featured-logos__logo"
                src="/images/logos/ft-adviser.png"
                alt="FT Adviser"
            />

            <img
                className="featured-logos__logo"
                src="/images/logos/money-observer.png"
                alt="Money Observer"
            />

            <img
                className="featured-logos__logo desktop-hide"
                src="/images/logos/the-times.png"
                alt="The Times"
            />

            <img
                className="featured-logos__logo"
                src="/images/logos/forbes.png"
                alt="Forbes"
            />
        </div>
        <a name="learn-more" />
    </section>
)

export default FeaturedLogos
